import { useCallback } from 'react';
import { useBatchId } from '../../../hooks/useBatchId';
import { useTranslation } from 'react-i18next';
import { FUNCTIONARY_HOME } from '../../../shared/Routes';
import { Button, Typography } from 'antd';
import LeftArrowWhite from '../../../assets/images/arrow-left-white.svg';
import LeftArrowBlack from '../../../assets/images/arrow-left.svg';
import Icon from '../../../components/ui-components/Icon';
import { ProposerDashboardSummaryTable } from './ProposerDashboardSummaryTable';
import { useProposerLoad } from './useProposerLoad';

const { Text } = Typography;

export const ProposerLoadDashboard = () => {
	const { applicationsList, onPageChange, paging } = useProposerLoad();
	const { t } = useTranslation();
	const { navigateToRoute } = useBatchId();

	const handleBackClick = useCallback(() => {
		navigateToRoute(FUNCTIONARY_HOME);
	}, [navigateToRoute]);

	return (
		<>
			<div className="md:hidden flex justify-center items-center pt-3 pb-1 relative">
				<Text className="font-sans font-bold text-lg mb-1">
					{t('proposerLoadDashboard')}
				</Text>
			</div>
			<div className="flex justify-between items-center pt-1 pb-3 px-5 md:px-5 md:py-5 relative">
				{/* Back Button - Desktop */}
				<Button
					type="primary"
					onClick={handleBackClick}
					className="hidden md:block font-bold text-sm"
				>
					<span className="flex gap-2">
						<Icon src={LeftArrowWhite} width="w-4" height="h-4" />
						{t('back')}
					</span>
				</Button>

				{/* Back Button + Title - Mobile */}
				<div className="block sm:hidden">
					<a
						onClick={handleBackClick}
						className="relative top:0 md:top-[3px] mr-2 font-bold text-sm"
					>
						<img src={LeftArrowBlack} width={'w-4'} height={'h-4'} />
					</a>
				</div>

				{/* Centered Title */}
				<Text className="hidden md:block font-sans font-bold text-xl mb-1 absolute left-1/2 transform -translate-x-1/2">
					{t('proposerLoadDashboard')}
				</Text>
			</div>
			<div className="hidden md:block px-4">
				<div className="border rounded-xl shadow-sm bg-white">
					<ProposerDashboardSummaryTable
						dataSource={applicationsList}
						onPageChange={onPageChange}
						pageConfig={paging}
					/>
				</div>
			</div>
		</>
	);
};
